import {styled} from '@linaria/react';
import React, {FC, SyntheticEvent, useMemo} from 'react';
import {COLORS} from '../../../constants/colors';
import {UnstyledButton} from '../../atoms/Buttons/UnstyledButton';
import {RadioButton} from '../../atoms/RadioButton/RadioButton';
import {OptionContent, OptionContentProps} from './OptionContent';
import {SizeOptionProps} from './types';

export const SizeOptionWithRadioButton: FC<
  SizeOptionProps &
    OptionContentProps & {
      onSizeSelect: (sizeId: number) => void;
    }
> = props => {
  const {
    className,
    dataTestId = 'sizeOption',
    id,
    selected,
    soldOut,
    onSizeSelect,
  } = props;

  const finalTestId = useMemo(() => {
    if (selected) {
      return `${dataTestId}_${id}_selected`;
    }

    if (soldOut) {
      return `${dataTestId}_${id}_disabled`;
    }

    return `${dataTestId}_${id}_active`;
  }, [selected, dataTestId, id, soldOut]);

  const handleOnClick = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onSizeSelect(id);
  };

  return (
    <Wrapper
      className={className}
      data-testid={finalTestId}
      onClick={handleOnClick}
      tabIndex={0}
      aria-label={undefined}
      data-selected={selected}
    >
      <StyledOptionContent {...props}>
        <StyledRadioButton checked={props.selected} />
      </StyledOptionContent>
    </Wrapper>
  );
};

const Wrapper = styled(UnstyledButton)`
  display: flex;
  padding: 0 16px;
  width: 100%;
  align-items: center;

  &[data-selected='true'] {
    background-color: ${COLORS['Fill.Grey.Primary']};
  }

  &:focus-visible {
    background-color: ${COLORS['Fill.Grey.Primary']};
  }
`;

const StyledRadioButton = styled(RadioButton)`
  position: relative;
  justify-content: center;
`;

const StyledOptionContent = styled(OptionContent)`
  flex: 1;
  padding: 16px 0px;
`;
